import { useQuery } from '@tanstack/react-query';
import { BehApiRoutes, behClient } from '../beh-api';

export function useDestinationsLastSync() {
  return useQuery<string | null>({
    queryKey: [BehApiRoutes.destinationsLastSync()],
    queryFn: () =>
      behClient
        .get<string>(BehApiRoutes.destinationsLastSync())
        .then((res) => res.data)
        .catch((err) => {
          if (err?.response?.status === 204) {
            return null;
          }
          throw err;
        })
  });
}
